exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1OJWcJhIQasOA0bQfjn5ra {\n  padding-top: 100px;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n._3EpBVY1BNAh1pvw6TZbj8 {\n  stroke-dasharray: 800;\n  -webkit-animation: _3-7A_47qK0wex1xjrfAY8N 2.5s infinite linear forwards;\n          animation: _3-7A_47qK0wex1xjrfAY8N 2.5s infinite linear forwards;\n}\n\n._1OJWcJhIQasOA0bQfjn5ra h3 {\n  text-transform: none;\n  margin-top: 25px;\n  font-family: 'proxima-nova';\n  font-size: 22px;\n  color: silver;\n  letter-spacing: 0.06em;\n}\n\n@-webkit-keyframes _3-7A_47qK0wex1xjrfAY8N {\n  0% {\n    stroke-dashoffset: 800;\n  }\n  100% {\n    stroke-dashoffset: -800;\n\n  }\n}\n\n@keyframes _3-7A_47qK0wex1xjrfAY8N {\n  0% {\n    stroke-dashoffset: 800;\n  }\n  100% {\n    stroke-dashoffset: -800;\n\n  }\n}", ""]);

// exports
exports.locals = {
	"ecgLoader": "_1OJWcJhIQasOA0bQfjn5ra",
	"pulse": "_3EpBVY1BNAh1pvw6TZbj8",
	"dash": "_3-7A_47qK0wex1xjrfAY8N"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/EcgLoader/EcgLoader.css
// module id = 3034
// module chunks = 23